import React from 'react';
import { motion } from 'framer-motion';
import { FaFacebook, FaInstagram, FaXTwitter, FaLinkedinIn } from 'react-icons/fa6';

const SocialLinks = () => {
  const socialIcons = [
    { Icon: FaInstagram, href: 'https://www.instagram.com/bookjacks?igsh=Y3RldXRwYWl2eHg0' },
    { Icon: FaLinkedinIn, href: 'https://www.linkedin.com/company/jacks-app/about/' }
  ];

  return (
    <div className="flex items-center space-x-6">
      {socialIcons.map(({ Icon, href }, index) => (
        <motion.a
          key={index}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="text-white hover:text-gray-200 transition-colors"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <Icon size={20} />
        </motion.a>
      ))}
    </div>
  );
};

export default SocialLinks;